import './splash-screen.scss';

import { Outlet } from "react-router-dom";

import { FilterSplashScreenProvider } from "./filter-splash-screen/filter-splash-screen.context";

export function SplashScreen() {
  return (
    <div id="ShellSplashScreen" className="splash-screen">
       <FilterSplashScreenProvider>
        <Outlet />
      </FilterSplashScreenProvider>
    </div>
  );
}

export default SplashScreen;
